/** Display-only helpers — no backend changes */

export function getCreatorName(idea) {
  return idea?.userId?.name || idea?.userId?.email || 'Student Creator';
}

export function getProjectTitle(idea, index) {
  return idea?.fileName || `Creative Project ${index + 1}`;
}

/** Stable pseudo-progress from id (30–92%) for UI when no funding API exists */
export function getFundingProgress(idea, fundedIds) {
  if (!idea?._id) return 0;
  if (fundedIds.includes(idea._id)) return 100;
  let hash = 0;
  const id = String(idea._id);
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash << 5) - hash + id.charCodeAt(i);
    hash |= 0;
  }
  return 30 + (Math.abs(hash) % 63);
}

export function getFundingGoalDisplay(idea) {
  let hash = 0;
  const id = String(idea?._id || '0');
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash << 5) - hash + id.charCodeAt(i);
    hash |= 0;
  }
  const base = 50000 + (Math.abs(hash) % 450000);
  return base;
}

export function formatCurrency(inr) {
  if (inr >= 100000) return `₹${(inr / 100000).toFixed(1)}L`;
  if (inr >= 1000) return `₹${Math.round(inr / 1000)}K`;
  return `₹${inr}`;
}

export function computeStats(ideas, fundedIds) {
  const totalProjects = ideas.length;
  const fundedCount = fundedIds.filter((id) => ideas.some((p) => p._id === id)).length;
  const raised = ideas.reduce((sum, idea) => {
    const goal = getFundingGoalDisplay(idea);
    const pct = getFundingProgress(idea, fundedIds) / 100;
    return sum + Math.round(goal * pct);
  }, 0);
  return {
    totalProjects,
    totalFundingRaised: raised,
    activeInvestors: Math.max(8, fundedCount * 4 + Math.min(totalProjects, 24)),
    successStories: fundedCount,
  };
}

export const FEATURED_GRADIENTS = [
  'linear-gradient(135deg, #1a2744 0%, #2d4a7c 50%, #c9a227 100%)',
  'linear-gradient(135deg, #0f172a 0%, #1e3a5f 45%, #d4af37 100%)',
  'linear-gradient(135deg, #141b2d 0%, #243b55 55%, #b8860b 100%)',
  'linear-gradient(135deg, #1c2541 0%, #3d5a80 40%, #e8c547 100%)',
];
